export default __webpack_public_path__ + "static/2024_Milan_Oct_EPK-min-c3d94f1afe9ebabd28cfafcca3c4f6c1.pdf";